<template>
  <div>
    <h1>Snatch search</h1>
    <p>The game of <i>Snatch</i>, also known as <i>Anagrams</i>, is a word game
      played with Bananagrams tiles.
      Starting with all of the tiles face-down, players flip tiles over one at a time. Once the
      visible tiles can create a word that is at least three letters long, players may
      call that word and take it for their own.
    </p>
    <div class="example">
      <div class="col">
        <div class="row">
          <span class="tile">T</span>
          <span class="operator">+</span>
          <span class="tile">C</span>
          <span class="operator">+</span>
          <span class="tile">A</span>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <span class="tile">C</span>
          <span class="tile">A</span>
          <span class="tile">T</span>
        </div>
      </div>
    </div>
    <p>
      Players can <i>snatch</i> words from other players (or from themselves) by adding one or
      more letters into existing words in play, as long as the newly created word does't
      share a root with the existing word (eg, pluralizations are not allowed). Letters
      can be added anywhere within words, and multiple words can be combined together as
      long as all letters are used.</p>
    <div class="example">
      <div class="col">
        <div class="row">
          <span class="tile">C</span>
          <span class="tile">A</span>
          <span class="tile">T</span>
        </div>
        <div class="row">
          <span class="operator">+</span>
        </div>
        <div class="row">
          <span class="tile">S</span>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <span class="tile">C</span>
          <span class="tile">A</span>
          <span class="tile new">S</span>
          <span class="tile">T</span>
        </div>
      </div>
    </div>
    <p>The game ends once no more words can be created, and the player with the most
    words of the longest lengths wins.</p>
    <p>Enter words or letters at the top of this page to find valid extensions.</p>
  </div>
</template>

<script>
export default {
  name: 'WelcomeContent',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;
    align-items: center;
  }

  p {
    line-height: 24px;
  }

  .example {
    display: flex;
    max-width: 600px;
  }

  .col {
    display: flex;
    flex-direction: column;
  }

  .row {
    display: flex;
    justify-content: center;
  }

  .tile, .operator {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px;
    border-radius: 4px;
  }

  .tile {
    background: #F8F1DE;
    font-size: 28px;
    width: 40px;
    height: 40px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.07);
    font-weight: 500;
  }

  .tile.new {
    margin-bottom: -5px;
    border-bottom: 5px solid #74d474;
  }

  .operator {
    font-size: 28px;
    width: 40px;
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/WelcomeContent.vue